import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';

export default function Navigation() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 w-full z-50 bg-white/95 backdrop-blur-sm border-b border-[#D0D5DD]">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 flex items-center justify-between h-16">
        {/* Logo */}
        <Link to="/" className="font-heading text-xl font-semibold text-[#101828] tracking-tight" data-testid="nav-logo">
          Mylikeness
        </Link>

        {/* Center Links */}
        <div className="hidden md:flex items-center gap-8">
          <Link to="/creators" className={`text-sm font-medium transition-colors ${isActive('/creators') ? 'text-[#2563EB]' : 'text-[#475467] hover:text-[#101828]'}`}>
            For Creators
          </Link>
          <Link to="/agencies" className={`text-sm font-medium transition-colors ${isActive('/agencies') ? 'text-[#2563EB]' : 'text-[#475467] hover:text-[#101828]'}`}>
            For Agencies
          </Link>
          <Link to="/trust" className={`text-sm font-medium transition-colors ${isActive('/trust') ? 'text-[#2563EB]' : 'text-[#475467] hover:text-[#101828]'}`}>
            Trust
          </Link>
        </div>

        {/* Right CTAs */}
        <div className="flex items-center gap-3">
          {user ? (
            <Button
              data-testid="nav-dashboard-btn"
              onClick={() => navigate(user.role === 'creator' ? '/creator' : user.role === 'admin' ? '/admin' : '/agency')}
              className="btn-primary text-sm h-10"
            >
              Dashboard
            </Button>
          ) : (
            <>
              <Button
                data-testid="nav-login-btn"
                variant="ghost"
                onClick={() => navigate('/login')}
                className="text-[#475467] hover:text-[#101828] text-sm font-medium"
              >
                Log in
              </Button>
              <Button
                data-testid="nav-signup-btn"
                onClick={() => navigate('/signup')}
                className="btn-primary text-sm h-10"
              >
                Create profile
              </Button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
